module.exports = __webpack_public_path__ + "static/media/Swis721_BT_Bold.93684bef.woff2";